import React from 'react'
import { Image } from 'react-bootstrap'
import logo from './../../assets/logo.jpeg';

const AuthLayout = ({children, title}) => {
  return (
    <div className='login-wrapper'>

        <div className="login-form-container">

            <Image src={logo} alt='APS Dashboard' className='logo' />

            <h2 className="login-title">{title}</h2>

            {children}

        </div>

    </div>
  )
}

export default AuthLayout